<router-outlet></router-outlet>
@if (chatEnabled && !isPublicUrl) {
  <div class="chat-global-container" id="chatGlobalContainer">
    <button tabindex="-1" mat-fab #tooltip="matTooltip" class="chat-bg-color"
      [matTooltip]="chatSessionActive ? 'Close Chat' : 'Open Chat'" [matTooltipPosition]="'left'" id="chatToggleButton"
      [matTooltipClass]="['global-icon-tooltip']" (click)="onToggleChat()">
      @if (!chatSessionActive) {
        <i class="fas fa-comment-alt" aria-hidden="true" id="chatIconOpen"></i>
      }
      @if (chatSessionActive) {
        <i class="fas fa-times" aria-hidden="true" id="chatIconClose"></i>
      }
    </button>
  </div>
}
<app-alert class="alert-container"></app-alert>